import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {RED_LIGHT, WHITE} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function LookupConfigModalErrorIndicator(props: {error: string}): JSX.Element {
  return (
    <>
      <div className={css(styles.lookupStepErrorIndicator)}>
        <BenchlingIcon className={css(styles.lookupStepErrorIndicatorIcon)} icon="cross-thick" />
      </div>
      <span className={css(styles.lookupStepErrorIndicatorText)}>{props.error}</span>
    </>
  );
}

const styles = StyleSheet.create({
  lookupStepErrorIndicator: {
    display: 'inline-block',
    backgroundColor: RED_LIGHT,
    color: WHITE,
    borderRadius: '50%',
    width: '12px',
    height: '12px',
    textAlign: 'center',
    lineHeight: '11px',
    marginLeft: '10px',
    marginRight: '4px',
  },
  lookupStepErrorIndicatorIcon: {
    width: '6px',
    height: '6px',
    marginBottom: '0px',
  },
  lookupStepErrorIndicatorText: {
    color: RED_LIGHT,
  },
});
